import type { Esteira } from "./implantacoes";

export type ModuloEmAndamento = Esteira["modulos"][number];

const NOMES_DAS_ETAPAS: Record<string, string> = {
  Integration: "Integração",
  "In Progress": "Em progresso",
  Training: "Treinamento",
  "Follow Up": "Acompanhamento",
  Done: "Concluído",
};

const STATUS_COM_CONTATO_DO_MODULO = new Set(["10030", "10031", "10001"]);
const STATUS_AGUARDANDO_CLIENTE = new Set([
  "waiting customer", "waiting for customer", "aguardando cliente", "paused", "pausado",
]);

export function aguardaClienteNoModulo(modulo: ModuloEmAndamento): boolean {
  return STATUS_AGUARDANDO_CLIENTE.has((modulo.jira_status_nome ?? "").trim().toLocaleLowerCase("pt-BR"));
}

export function nomeDaEtapaDoModulo(nome: string | null | undefined): string | null {
  if (!nome) return null;
  return NOMES_DAS_ETAPAS[nome] ?? nome;
}

export function contatoDoModulo(modulo: ModuloEmAndamento, contatoDaConta: Esteira["contato"]) {
  return modulo.jira_status_id && STATUS_COM_CONTATO_DO_MODULO.has(modulo.jira_status_id)
    ? { nome: modulo.jira_responsavel_nome, email: modulo.jira_responsavel_email }
    : contatoDaConta;
}
